import ReactTooltip from "react-tooltip";
import Icon3 from "../../../assets/icon/icon3.png";
import { ISprint } from "@hero/shared/models/sprint";
import { ICoefficients, IUserInfo } from "@hero/shared/models/userInfo";
import { formatDate } from "../../../util";
import "./style.scss";
import { ITaskScores } from "@hero/shared/models/taskScore";
import NewProgressBar from "../expectation-and-notification/NewProgressBar";
import MyAvatar from "../../avatar";
import TaskOverviewWidget from "./TaskOverviewWidget";

const UserIndicator = ({
    user,
    sprint,
    isUserAuthStaff = false,
    disciplinePoints,
    taskScores,
    coefs,
}: {
    user: IUserInfo;
    sprint: ISprint;
    isUserAuthStaff?: boolean;
    disciplinePoints: any;
    taskScores: ITaskScores;
    coefs: ICoefficients;
}) => {
    let doneRate = taskScores?.doneRate.value ?? 0;
    return (
        <>
            <div className="container-completion-rate">
                <div className="container-content">
                    {!isUserAuthStaff && (
                        <div
                            className="avatar flex align-item-center"
                            style={{ flexDirection: "row-reverse" }}
                        >
                            <div className="avatar-image align-item-center justify-content-center">
                                <MyAvatar url={user.avatar} />
                            </div>
                            <div className="column" style={{ justifyContent: "space-between", marginRight: "10px", textAlign: "end" }}>
                                <div className="white first-name">{user.firstName}</div>
                                <div className="position">{user.position}</div>
                                <div className="level">{"Level: " + user.level}</div>
                            </div>
                        </div>
                    )}

                    {/* Task overview — thay thế Điểm kinh nghiệm */}
                    <TaskOverviewWidget userId={user._id} sprint={sprint} />

                    <div style={{ padding: "4px 0 8px" }}>
                        <div style={{ fontSize: 11, color: "rgba(255,255,255,0.4)", marginBottom: 4, fontWeight: 600 }}>
                            Thống kê task
                        </div>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 4 }}>
                            <StatItem label="Trong sprint" value={taskScores?.totalTaskInSprint.value ?? 0} color="#8b95a5" />
                            <StatItem label="Hoàn thành" value={taskScores?.tasksDone.value ?? 0} color="#4caf50" />
                            <StatItem label="Đúng deadline" value={taskScores?.taskDoneInDeadline.value ?? 0} color="#4da1ff" />
                            <StatItem label="Point" value={`${taskScores?.pointDone.value ?? 0}/${taskScores?.totalPoint?.value ?? 0}`} color="#ff9800" />
                            <StatItem label="Hoàn thành" value={`${taskScores?.taskDonePercentage.value ?? 0}%`} color={doneRate >= 80 ? "#4caf50" : doneRate >= 50 ? "#ff9800" : "#f44336"} />
                            <StatItem label="Đúng hạn" value={`${taskScores?.taskDoneInDeadlinePercentage.value ?? 0}%`} color={taskScores?.taskDoneInDeadlinePercentage.value >= 80 ? "#4caf50" : "#ff9800"} />
                        </div>
                    </div>
                    <div className="container-group">
                        <div className="group-content" data-tip data-for={"disciplineTip" + user._id}>
                            <img className="all-icon" src={Icon3} />
                            <div className="container-ratio">
                                <span className="title-content">Kỷ luật</span>
                                <div className="group-text">
                                    <span className="text-point">{100 - (disciplinePoints?.minusScore ?? 0)}</span>
                                    <div className="group-ratio discipline">
                                        <span className={"point-discipline " + (!disciplinePoints ? "point-done" : "")}>
                                            {disciplinePoints ? "-" + (disciplinePoints?.minusScore ?? 0) : 0}
                                        </span>
                                        <NewProgressBar
                                            current={
                                                100 - (disciplinePoints?.minusScore ?? 0) < 0
                                                    ? 0
                                                    : 100 - (disciplinePoints?.minusScore ?? 0)
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <ReactTooltip id={"disciplineTip" + user._id} type="info">
                                <div style={{ display: "block" }}>
                                    <div>
                                        <strong>Số ngày lỗi chấm công: {disciplinePoints?.workingTime?.length ?? 0}</strong>
                                        {disciplinePoints?.workingTime?.map((d: any, index: number) => (
                                            <div key={index}>&#x2022; {`${formatDate(new Date(d.date), "dd/mm/yyyy")}: ${d.reason}`}</div>
                                        ))}
                                    </div>
                                    <div>
                                        <strong>Số lần nghỉ vi phạm: {disciplinePoints?.offDaysUnauthorized?.length ?? 0}</strong>
                                        {disciplinePoints?.offDaysUnauthorized?.length > 0 &&
                                            disciplinePoints?.offDaysUnauthorized?.map((d: any, index: number) => (
                                                <div key={index}>&#x2022; {`${formatDate(new Date(d.date), "dd/mm/yyyy")}: ${d.reason}`}</div>
                                            ))}
                                    </div>
                                </div>
                            </ReactTooltip>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const StatItem = ({ label, value, color }: { label: string; value: string | number; color: string }) => (
    <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "3px 8px",
        borderRadius: 6,
        background: "rgba(255,255,255,0.04)",
        fontSize: 11,
    }}>
        <span style={{ color: "rgba(255,255,255,0.5)" }}>{label}</span>
        <span style={{ fontWeight: 700, color }}>{value}</span>
    </div>
);

export default UserIndicator;
